var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.home)?_c('main',{staticClass:"home"},[_c('ul',{staticClass:"featured"},_vm._l((_vm.home.featured),function(featured,key){return _c('li',{key:("featured" + ((key + 1))),staticClass:"featured__item",class:{
        'featured__item--active': _vm.activeItem === key
      }},[_c('img',{class:{
          'portrait': featured.image.height >= featured.image.width,
          'landscape': featured.image.width > featured.image.height
        },attrs:{"src":featured.image.url}}),_c('aside',{style:({
          width: Number.parseInt((100 / _vm.home.featured.length), 10) + '%',
          left: (Number.parseInt((100 / _vm.home.featured.length), 10) * key) + '%',
          right: ((((_vm.home.featured.length - key)) * 18) + 10) + 'px',
          height: '100vh',
          minHeight: '720px'
        }),on:{"mouseenter":function($event){_vm.activeItem = key},"click":function($event){return _vm.updateActive(key)}}})])}),0),_c('Navigation',{attrs:{"active":true}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }